module.exports = __webpack_public_path__ + "static/ashly-getty-336d5474273354e63652461c744470af.jpg";